import React, { useEffect } from 'react';
import { Text } from './Text';
import { Flex } from './Flex';

export type ToastType = 'success' | 'error' | 'info';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

interface ToastProps {
  toast: Toast;
  onClose: (id: string) => void;
}

export const ToastComponent: React.FC<ToastProps> = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast.duration !== 0) {
      const timer = setTimeout(() => {
        onClose(toast.id);
      }, toast.duration || 5000);

      return () => clearTimeout(timer);
    }
  }, [toast.id, toast.duration]); // Removed onClose from deps to prevent timer resets

  const bgColor = 
    toast.type === 'error' ? 'bg-red-500/90' :
    toast.type === 'success' ? 'bg-green-500/90' :
    'bg-blue-500/90';

  const borderColor =
    toast.type === 'error' ? 'border-red-400' :
    toast.type === 'success' ? 'border-green-400' :
    'border-blue-400';

  return (
    <div
      className={`
        ${bgColor}
        border ${borderColor}
        rounded-lg
        shadow-lg
        px-4 py-3
        min-w-[300px]
        max-w-[500px]
        animate-[slideIn_0.3s_ease-out]
        cursor-pointer
        hover:opacity-90
        transition-opacity
      `}
      style={{
        willChange: 'transform, opacity',
        transform: 'translateZ(0)',
      }}
      onClick={() => onClose(toast.id)}
    >
      <Flex align="center" gap={2}>
        <Text variant="title" size="sm" color="white">
          {toast.message}
        </Text>
      </Flex>
    </div>
  );
};
